import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import {
  updateClaimAdjustmentCode,
} from 'redux/modules/claimAdjustmentCodes';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch, props) {
  if (props.ID) {
    if (props.pristine) {
      throw new SubmissionError({
        _error: 'Nothing to submit',
      });
    }
    const diffValues = objectDiff(values, props.initialValues);
    return new Promise((resolve, reject) => {
      dispatch(updateClaimAdjustmentCode({
        values: {
          ID: props.ID,
          ...diffValues,
        },
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        throw new SubmissionError({ _error: err.error.indexOf('Unique check fail') !== -1
          ? 'Sorry, but such Claim Code already exists' : err.error });
      });
  }

  throw new SubmissionError({
    _error: 'Claim Code creation not allowed',
  });
}

const ClaimAdjustmentCodeCreateEditForm = ({
  handleSubmit,
  className,
  error,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Code"
          name="Code"
          label="Code"
          component={TextField}
          errorPlacement="bottom"
          fullWidth
          disabled
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Description"
          name="Description"
          label="Description"
          component={TextField}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

ClaimAdjustmentCodeCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimAdjustmentCodeCreateEditForm.defaultProps = {
  className: '',
  error: null,
};

export default reduxForm({
  form: 'claimAdjustmentCodeEdit',
  onSubmit,
})(withStyles(styles)(ClaimAdjustmentCodeCreateEditForm));



// WEBPACK FOOTER //
// ./src/components/settings/ClaimAdjustmentCodeCreateEditDialog/ClaimAdjustmentCodeCreateEditForm.js